"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// All translations related to login data
var Login = {
  login: {
    nl: 'Meld je aan',
    fr: 'Connecter',
    en: 'Log in'
  },
  logout: {
    nl: 'Meld je af',
    fr: 'Deconnecter',
    en: 'Log out'
  },
  instructions: {
    nl: 'Stuur mij instructies',
    fr: 'Envoie moi des instructions',
    en: 'Send me instructions'
  },
  username: {
    nl: 'Gebruikersnaam',
    fr: "Nom d'utilisateur",
    en: 'Username'
  },
  password: {
    nl: 'Wachtwoord',
    fr: 'Mot de passe',
    en: 'Password'
  },
  password_repeat: {
    nl: 'Wachtwoord herhalen',
    fr: 'Répéter le mot de passe',
    en: 'Repeat password'
  },
  password_forgot: {
    nl: 'Wachtwoord vergeten?',
    fr: 'Oublié mot de passe ?',
    en: 'Forgot password?'
  },
  password_remember: {
    nl: 'Ik weet mijn wachtwoord weer!',
    fr: 'Je me suis rappelé mon mot de passe!',
    en: "Wait! I remember my password!"
  },
  message_forgot: {
    nl: "Geen zorgen, gebeurt iedereen wel eens ;)",
    fr: "Ne vous inqui\xE9tez pas, cela arrive aux meilleurs d'entre nous;)",
    en: "Don't worry, it happens to the best of us ;)"
  },
  feedback_mail_empty: {
    nl: 'Gelieve een e-mail adres in te vullen',
    fr: "Rempli votre adresse e-mail s'il vous plaît",
    en: 'Please fill in your email address'
  },
  feedback_mail_incorrect: {
    nl: 'We vinden geen gegevens met dit e-mail adres; typfoutje gemaakt?',
    fr: "Nous ne pouvons trouver aucune donnée avec cette adresse e-mail; faute de frappe?",
    en: "We can't find any data with this e-mail address; made a typo?"
  },
  feedback_mail_wrong: {
    nl: 'Dit e-mail adres bestaat niet',
    fr: "Cette adresse e-mail n'existe pas",
    en: "This email address does'nt exist"
  },
  feedback_pw_empty: {
    nl: 'Wees niet bang om je wachtwoord in te vullen',
    fr: "N'ayez pas peur de saisir votre mot de passe",
    en: "Don't be afraid to fill in your password"
  },
  feedback_pw_incorrect: {
    nl: 'Oeps! Dit is niet het juiste wachtwoord. Probeer nog eens als je wilt?',
    fr: "Oups! Ce n'est pas le bon mot de passe. Essaie encore si tu veux?",
    en: 'Oops! This is not the correct password. Try again if you want?'
  },
  feedback_unkown: {
    nl: 'Er is een onbekend probleem; we kijken dit na.',
    fr: 'Il y a un problème inconnu. nous vérifions cela.',
    en: "There is an unknown problem; we'll check this."
  },
  mail_sent: {
    nl: 'E-mail is verzonden!',
    fr: 'Le courrier a été envoyé!',
    en: 'Mail has been sent!'
  },
  mail_sent_error: {
    nl: 'Kan geen mail verzenden',
    fr: 'Impossible d\'envoyer du courrier',
    en: 'Can\'t send mail'
  },
  logo_alt: {
    nl: 'Logo Ondernemersnetwerk',
    fr: 'Logo Reseau Entrepreneurs',
    en: 'Logo Entrepreneursnetwork'
  },
  i_am: {
    nl: 'Ik ben een...',
    fr: 'Je suis un...',
    en: 'I am an...'
  },
  user: {
    nl: 'Gebruiker',
    fr: 'Utilisateur',
    en: 'User'
  },
  entrepreneur: {
    nl: 'Ondernemer',
    fr: 'Entrepreneur',
    en: 'Entrepreneur'
  },
  log_in: {
    nl: 'Inloggen',
    fr: 'Connexion',
    en: 'Log in'
  },
  sign_in: {
    nl: 'Registreren',
    fr: 'Inscription',
    en: 'Sign up'
  },
  create_account: {
    nl: 'Maak account',
    fr: 'Créer un compte',
    en: 'Create account'
  },
  log_in_instead: {
    nl: 'Toch inloggen',
    fr: 'Connexion',
    en: 'Log in instead'
  },
  publish: {
    nl: 'Publiceren',
    fr: 'Publier',
    en: 'Publish'
  },
  login_error: {
    nl: 'Log eerst in alstublieft',
    fr: "S'il vous plait connectez-vous d'abord",
    en: 'Please login first'
  },
  company_details: {
    nl: 'Bedrijfsgegevens',
    fr: "Détails de l'entreprise",
    en: 'Enterprise detials'
  },
  contact_options: {
    nl: 'Contacteer mij via:',
    fr: "Contactez moi via:",
    en: 'Cotnact me via:'
  },
  firstname: {
    nl: 'Voornaam',
    fr: 'Prénom',
    en: 'Firstname'
  },
  lastname: {
    nl: 'Achternaam',
    fr: 'Nom',
    en: 'Lastname'
  },
  telephone: {
    nl: 'Telefoonnummer',
    fr: 'Numéro telephone',
    en: 'Telephone number'
  },
  cellphone: {
    nl: 'GSM-nummer',
    fr: 'Numéro de portable',
    en: 'Cellphone number'
  },
  email: {
    nl: 'E-mailadres',
    fr: 'Adresse e-mail',
    en: 'E-mail address'
  },
  enterprise_name: {
    nl: 'Maatschappelijke naam',
    fr: "Nom d'entreprise",
    en: 'Enterprise name'
  },
  trade_name: {
    nl: 'Handelsnaam',
    fr: 'Nom commercial',
    en: 'Trade name'
  },
  vat_number: {
    nl: 'BTW nummer',
    fr: 'Numéro de TVA',
    en: 'VAT number'
  },
  enterprise_phone: {
    nl: 'Telefoonnummer van bedrijf',
    fr: "Numéro telephone d'entreprise",
    en: 'Telephone number of enterprise'
  },
  enterprise_mail: {
    nl: 'E-mailadres van bedrijf',
    fr: "Adresse e-mail d'entreprise",
    en: 'E-mail address of enterprise'
  },
  enterprise_fax: {
    nl: 'Fax van bedrijf',
    fr: "Fax d'entreprise",
    en: 'Fax of enterprise'
  },
  contact_us: {
    nl: 'Contacteer ons',
    fr: 'Contacter nous',
    en: 'Contact us'
  },
  contact_me: {
    nl: 'Contacteer mij',
    fr: 'Contactez moi',
    en: 'Contact me'
  },
  contact: {
    nl: 'Contacteer',
    fr: 'Contacter',
    en: 'Contact'
  },
  contact_details: {
    nl: 'Contactgegevens',
    fr: 'Informations de contact',
    en: 'Contact details'
  },
  enterprise_details: {
    nl: 'Bedrijfsgegevens',
    fr: "Informations d'entreprise",
    en: 'Enterprise details'
  },
  forgot_password: {
    nl: 'Wachtwoord vergeten?',
    fr: 'Oublié mot de passe?',
    en: 'Forgot password?'
  }
};
var _default = Login;
exports["default"] = _default;